import React, { useState, useEffect, useCallback } from "react";
import { Box, IconButton, Divider } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import Menu from "./menu";
import model from "./menuModel";
import { useTranslation } from "../../locale/useTranslation";
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOCALSTORAGE_KEY } from "../../framework/constant/constant";
import { utility } from "../../framework/utility/utilityProvider";
import { sidebarTheme, scrollbarStyles } from "./SidebarStyles";

const Navbar = (props) => {
    const lang = useTranslation();
    const user = utility.getValue(LOCALSTORAGE_KEY.userData);
    const [userMenus, setUserMenus] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const baseURL = window.location.protocol + window.location.host;
    const isAirSync = baseURL.includes("airsync");

    useEffect(() => {
        const updateScreenType = () => {
            const isPortrait = window.innerHeight > window.innerWidth;
            setIsMobile(isPortrait);
        };

        updateScreenType();
        window.addEventListener("resize", updateScreenType);
        return () => window.removeEventListener("resize", updateScreenType);
    }, []);

    const getUserFavouriteMenus = useCallback(async () => {
        const pageReloadCountData = utility.getValue("PageReloadCount");
        if (pageReloadCountData === undefined) {
            var menus = await API.getDataLookup(
                ENTITYNAME.UserFavouriteMenu,
                { query: ["User_id", "=", user._id] },
                { sort: { Name: 1 } }
            );
            utility.setValue(LOCALSTORAGE_KEY.userfavouritemenu, menus.data);
            utility.setValue("PageReloadCount", 1);
            setUserMenus(menus.data);
            return menus.data;
        }
    }, [user]);

    useEffect(() => {
        document.addEventListener("updateMenu", getUserFavouriteMenus);
        getUserFavouriteMenus();
        return () => {
            document.removeEventListener("updateMenu", getUserFavouriteMenus);
        };
    }, [getUserFavouriteMenus]);

    const drawerWidth = props.isMinified
        ? sidebarTheme.drawerWidthMinified
        : sidebarTheme.drawerWidth;

    if (isMobile) {
        return null;
    }

    // Use left-menu class for proper height inheritance from CSS
    return (
        <div
            className={isAirSync ? "left-menu-blue" : "left-menu"}
            style={{
                width: drawerWidth,
                minWidth: drawerWidth,
                flexShrink: 0,
                backgroundColor: isAirSync ? "#1a237e" : sidebarTheme.backgroundColor,
                transition: sidebarTheme.transition,
                overflowX: "hidden",
                overflowY: "hidden",
                display: "flex",
                flexDirection: "column",
                paddingBottom: 0, // Override the 20px from CSS
            }}
        >
            {/* Menu Section - scrollable */}
            <Box
                sx={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    minHeight: 0,
                    ...scrollbarStyles,
                }}
            >
                <Menu
                    menuModel={model(lang, userMenus, user)}
                    isMinified={props.isMinified}
                />
            </Box>

            <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />

            {/* Collapse Button - fixed at bottom */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: props.isMinified ? "center" : "flex-end",
                    p: 0.5,
                    flexShrink: 0,
                }}
            >
                <IconButton
                    onClick={props.onMinifyMenuClick}
                    size="small"
                    sx={{
                        color: sidebarTheme.textColorMuted,
                        "&:hover": {
                            backgroundColor: sidebarTheme.hoverBg,
                        },
                    }}
                >
                    {props.isMinified ? (
                        <ChevronRightIcon fontSize="small" />
                    ) : (
                        <ChevronLeftIcon fontSize="small" />
                    )}
                </IconButton>
            </Box>
        </div>
    );
};

export default Navbar;